import { useEffect, useState } from "react";

import { animatePage, animatePageNotOpacity } from "../../animateConstant";

import CloseDetailPage from "../../components/CloseComponent/CloseDetailPage";
import InboxItem from "./InboxItem";
import { useDispatch, useSelector } from "react-redux";
import { getFixedStyle } from "../../hook/useDeviceType";
import { useTranslation } from "react-i18next";
import LoadingBlock from "../../components/Loading/LoadingBlock";
import NotFound from "../../components/ProgressBlock/NotFound";
import DetailWrapper from "../../components/detailWrapper";
import { getInboxList } from "../../api/getApi";
import ButtonTab from "../../components/TabComponent/ButtonTab";
import InboxList from "./components/inboxList";
import NewsList from "./components/newsList";

const Inbox = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`inbox.${key}`);

  const TAB = [
    { label: i18n("inbox"), value: "inbox" },
    { label: i18n("news"), value: "news" },
  ];

  const [tab, setTab] = useState(TAB[0].value);
  return (
    <DetailWrapper>
      <CloseDetailPage title={i18n("title")} />
      <section className="mb-[20px]">
        <ButtonTab TABS={TAB} setTab={setTab} tab={tab} />
      </section>

      <section className="p-common-padding-x">
        {tab === "inbox" ? <InboxList isInbox /> : <NewsList />}
      </section>
    </DetailWrapper>
  );
};

export default Inbox;
